import React, { useEffect, useState } from "reactn";
import { debug } from "state/api";

export const useAccount = (mobile) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [resolved, setResolved] = useState(false);

	const recover = async (user) => {
		if (!user) {
			setError("Debes ingresar un correo electrónico válido");
			return;
		}

		try {
			setLoading(true);
			const req = await fetch("https://zeroq.cl/login/resetPassword", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: mobile
					? JSON.stringify({ user: user })
					: JSON.stringify(user),
			});
			const res = await req.json();
			const data = await res;
			if (req.status !== 200) {
				throw new Error(data.message);
			}

			if (data) {
				setError(null);
				setLoading(false);
				setResolved(true);
			}
		} catch (error) {
			if (error.message === "EMAIL_NOT_FOUND") {
				setLoading(false);
				setError({
					message:
						"El email ingresado no existe, por favor verifiquelo e intente nuevamente.",
					debug: error,
				});
				setTimeout(() => setError(null), 10000);
				return;
			}
			if (error.message === "RESET_PASSWORD_EXCEED_LIMIT") {
				setLoading(false);
				setError({
					message:
						"Se ha excedido el numero de solicitudes, por favor intente más tarde.",
					debug: error,
				});
				setTimeout(() => setError(null), 10000);
				return;
			}
			if (
				error.message === "Rate exceeded" ||
				error.message === "nate exceeded" ||
				error.message ===
					"QUOTA_EXCEEDED : Exceeded daily quota for resetting passwords."
			) {
				setLoading(false);
				setError({
					message:
						"Se ha excedido el numero de solicitudes diarias, por favor intente más tarde.",
					debug: error,
				});
				setTimeout(() => setError(null), 10000);
				return;
			}
			setError({
				message: "Por favor intente más tarde.",
				debug: error,
			});
			setLoading(false);
			setResolved(false);
		}
	};

	return [recover, loading, resolved, error];
};

export const useAccountForModal = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [resolved, setResolved] = useState(false);

	const recover = async (user) => {
		if (!user) {
			setError("Debes ingresar un correo electrónico válido");
			return;
		}

		setLoading(true);
		window
			.fetch("https://zeroq.cl/login/resetPassword", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(user),
			})
			.then(() => {
				setError(null);
				setLoading(false);
				setResolved(true);
				setTimeout(() => setResolved(false), 30000);
			})
			.catch((e) => {
				setError(e);
				setLoading(false);
				setResolved(false);
			});
	};

	return [recover, loading, error, resolved];
};
